import { Button, Container, Grid } from "@material-ui/core";
import { useTemplateStyles } from "@saleor/dropOff/styles/templates";
import { GetTemplate_template_dropOffLocations_edges_node } from "@saleor/dropOff/types/GetTemplate";
import { dropOffEditPath, dropOffUrl } from "@saleor/dropOff/url";
import { TemplateAction } from "@saleor/dropOff/utils/handlers";
import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import { stringifyQs } from "@saleor/utils/urls";
import * as React from "react";
import urlJoin from "url-join";

import DropOffManageHomeLocation from "./DropOffManageHomeLocation";

interface DropOffHomeLocationAndTaskAreaProps {
  mallId: string;
  templateId: string;
  templateAction: TemplateAction;
  editHomeLocation: GetTemplate_template_dropOffLocations_edges_node;
  nextStep?: () => void;
  onBack?: () => void;
}

const DropOffHomeLocationAndTaskArea: React.FC<DropOffHomeLocationAndTaskAreaProps> = props => {
  const {
    mallId,
    templateId,
    templateAction,
    editHomeLocation,
    nextStep,
    onBack
  } = props;

  const classes = useTemplateStyles(props);
  const notify = useNotifier();
  const navigate = useNavigator();

  const [homeLocations, setHomeLocations] = React.useState<
    GetTemplate_template_dropOffLocations_edges_node[]
  >([]);

  const checkForNext = () => {
    let canNext = false;
    let allHaveTaskAreas = true;
    homeLocations.forEach(homeLoc => {
      if (homeLoc?.taskAreas.length === 0) {
        allHaveTaskAreas = false;
      }
    });

    if (homeLocations.length > 0 && allHaveTaskAreas) {
      canNext = true;
    }

    if (canNext) {
      nextStep();
    } else {
      notify({
        status: "error",
        text: "Home location and task area cannot be empty"
      });
    }
  };

  const checkForNextEdit = () => {
    let canNext = false;
    let allHaveTaskAreas = true;
    homeLocations.forEach(homeLoc => {
      if (homeLoc?.taskAreas.length === 0) {
        allHaveTaskAreas = false;
      }
    });

    if (homeLocations.length > 0 && allHaveTaskAreas) {
      canNext = true;
    }
    const url =
      templateAction === TemplateAction.EDIT
        ? dropOffEditPath(templateId)
        : dropOffUrl(templateId);

    if (canNext) {
      navigate(
        urlJoin(
          url,
          "?" +
            stringifyQs({
              mall: mallId,
              step: 2
            })
        )
      );
    } else {
      notify({
        status: "error",
        text: "Home location and task area cannot be empty"
      });
    }
  };

  return (
    <Container>
      <div className={classes.GeneralInformationRoot}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <DropOffManageHomeLocation
              mallId={mallId}
              templateId={templateId}
              setHomeLocations={setHomeLocations}
              templateAction={templateAction}
              templateDefaultHomeLoc={editHomeLocation}
            />
          </Grid>
        </Grid>

        {templateAction === TemplateAction.CREATE ? (
          <div
            className={`${classes.displayFlex} ${classes.displayFlexPaddingTop50} ${classes.displayFlexMarginRight30}`}
          >
            <Button
              color="primary"
              variant="outlined"
              className={classes.displayFlexMarginLeft}
              onClick={() => onBack()}
            >
              <div className={classes.textBackButton}>BACK</div>
            </Button>

            <Button
              variant="contained"
              className={`${classes.buttonColor} ${classes.displayFlexMarginLeft20}`}
              onClick={checkForNext}
            >
              <div className={classes.textButton}>NEXT</div>
            </Button>
          </div>
        ) : (
          <div
            className={`${classes.displayFlex} ${classes.displayFlexPaddingTop50} ${classes.displayFlexMarginRight30}`}
          >
            <Button
              variant="contained"
              className={`${classes.buttonColor} ${classes.displayFlexMarginLeft}`}
              onClick={checkForNextEdit}
            >
              <div className={classes.textButton}>NEXT</div>
            </Button>
          </div>
        )}
      </div>
    </Container>
  );
};

export default DropOffHomeLocationAndTaskArea;
